import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import Layout from "@/components/Layout";
import { 
  Eye, 
  Zap, 
  Settings, 
  BarChart3, 
  Target, 
  Layers, 
  ArrowRight,
  CheckCircle,
  Download
} from "lucide-react";

const Products = () => {
  const products = [
    {
      id: "seeod",
      name: "几何光学仿真",
      title: "几何光学仿真",
      subtitle: "高精度光线追迹与系统优化",
      description: "几何光学仿真突破光学系统的高精度光线追迹、多变量多目标的自动优化和公差分析等关键技术，为各个行业的光学系统分析和设计提供支撑。",
      image: "./images/seeod产品图片.png",
      icon: <Eye className="w-8 h-8" />,
      color: "blue",
      features: [
        {
          title: "自动绘图",
          description: "能够对光学系统零件按国家标准进行自动绘制，可保存图片或导出.dxf格式的标准图纸",
          icon: <Settings className="w-5 h-5" />
        },
        {
          title: "波动像分析",
          description: "支持波前图、PSF和MTF功能，支持系统对光线偏差、成像质量、系统分辨率的分析",
          icon: <BarChart3 className="w-5 h-5" />
        },
        {
          title: "公差分析",
          description: "支持公差分析，根据光学和机械公差要求，对表面和元件进行灵敏度、反灵敏度和蒙特卡洛等公差分析",
          icon: <Target className="w-5 h-5" />
        },
        {
          title: "多种优化算法",
          description: "研发了多种高效的优化算法，可以进一步提升多种不同系统的设计性能和用户体验",
          icon: <Zap className="w-5 h-5" />
        },
        {
          title: "成像模拟",
          description: "支持成像效果模拟，能够评估和分析图像的清晰度、分辨率等特性，以便优化光学系统成像效果",
          icon: <Eye className="w-5 h-5" />
        },
        // {
        //   title: "杂散光分析",
        //   description: "通过光线追踪和散射模型，分析光学系统中的杂散光产生机制，仿真模拟杂散光的分布情况",
        //   icon: <Layers className="w-5 h-5" />
        // }
      ],
      capabilities: [
        "支持透射式、同轴折反、离轴折反以及棱镜系统等不同类型的复杂光学系统",
        "能够对标准球面、偶次非球面、多项式面等自由曲面以及柱面等面型优化",
        "支持对不同视场不同系统像差条件下对不同场景的成像效果进行高置信度批量仿真模拟",
        "通过模拟光线在系统中的传播并跟踪其交互作用，计算并分析可能出现的鬼点鬼像"
      ]
    },
    // {
    //   id: "seelight",
    //   name: "SeeLight",
    //   title: "物理光学仿真",
    //   subtitle: "专业级的激光/光纤仿真软件",
    //   description: "SeeLight拥有强大的模型和丰富的案例，72个基础光学元件模型、8个光纤激光元件模型，满足不同场景的仿真模拟需求。",
    //   image: "./images/seelight产品图片.jpg",
    //   icon: <Zap className="w-8 h-8" />,
    //   color: "green",
    //   features: [
    //     {
    //       title: "丰富的元件库",
    //       description: "72个基础光学元件模型、8个光纤激光元件模型，满足不同场景的仿真模拟需求",
    //       icon: <Layers className="w-5 h-5" />
    //     },
    //     {
    //       title: "应用实例",
    //       description: "内置基础光学和光纤52个应用实例，囊括光学基础教学的大部分内容",
    //       icon: <BarChart3 className="w-5 h-5" />
    //     },
    //     {
    //       title: "灵活配置",
    //       description: "可根据实际教学/研究需要选择适合的元件/案例",
    //       icon: <Settings className="w-5 h-5" />
    //     }
    //   ],
    //   capabilities: [
    //     "支持激光传播、光束整形、光纤耦合等多种物理光学现象仿真",
    //     "提供完整的光纤激光器系统建模和仿真功能",
    //     "支持非线性光学效应的精确计算和分析",
    //     "适用于教学、科研和工程应用等多个领域"
    //   ]
    // },
    {
      id: "seethinfilm",
      name: "薄膜优化与误差分析",
      title: "薄膜优化与误差分析",
      subtitle: "光学薄膜系统优化设计软件",
      description: "薄膜优化与误差分析主要为满足各种类型和用途的光学薄膜系统(如增透膜、保偏膜、光学滤波器等)在设计、仿真环节中的应用需求而开发。",
      image: "./images/SeeThinFilm产品图片.png",
      icon: <Layers className="w-8 h-8" />,
      color: "purple",
      features: [
        {
          title: "复合薄膜光谱参数仿真",
          description: "利用传输矩阵法对薄膜系统在不同波长、不同入射角度、单层厚度变化下的光学性能进行分析",
          icon: <BarChart3 className="w-5 h-5" />
        },
        {
          title: "膜系设计分析",
          description: "光谱仿真功能数据与第三方软件的相对偏差保持在1E-5以内，仿真具备较高的准确性",
          icon: <Target className="w-5 h-5" />
        },
        {
          title: "公差分析功能",
          description: "基于蒙特卡罗法建模的误差预测功能，支持阈值判定自适应/支持层间误差耦合处理",
          icon: <Settings className="w-5 h-5" />
        }
      ],
      capabilities: [
        "包括反射率、透射率、吸收率、相位、色散等参数的数据计算和图像展示",
        "导纳分析中单次计算效率达毫秒级，与第三方软件绝对误差在1E-10内",
        "电场分布仿真跨介质界面场强连续性误差小于0.1%，计算准确度优于第三方软件",
        "厚度和折射率可以联合/独立考虑，预测生产后膜系的光谱可视化"
      ]
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      blue: {
        bg: "bg-blue-50",
        text: "text-blue-600",
        border: "border-blue-200",
        button: "bg-blue-600 hover:bg-blue-700"
      },
      green: {
        bg: "bg-green-50",
        text: "text-green-600",
        border: "border-green-200",
        button: "bg-green-600 hover:bg-green-700"
      },
      purple: {
        bg: "bg-purple-50",
        text: "text-purple-600",
        border: "border-purple-200",
        button: "bg-purple-600 hover:bg-purple-700"
      }
    };
    return colors[color as keyof typeof colors] || colors.blue;
  };

  return (
    <Layout>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            {/* <Badge variant="outline" className="mb-3 text-sm border-blue-300 text-blue-700 bg-blue-50">
              核心产品
            </Badge> */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              产品与服务
            </h1>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              以光学技术为核心，提供软件开发、仪器销售与数据服务的综合解决方案
            </p>
            
            {/* Quick Navigation Buttons */}
            {/* <div className="flex flex-wrap justify-center gap-3 mt-6">
              {products.map((product) => {
                const colorClasses = getColorClasses(product.color);
                return (
                  <Button 
                    key={product.id}
                    variant="outline"
                    size="sm"
                    className={`px-4 py-2 border ${colorClasses.border} ${colorClasses.text} hover:${colorClasses.bg} transition-colors text-sm`}
                    onClick={() => {
                      document.getElementById(product.id)?.scrollIntoView({ 
                        behavior: 'smooth' 
                      });
                    }}
                  >
                    {product.icon}
                    <span className="ml-1.5 font-medium">{product.name}</span>
                  </Button>
                );
              })}
            </div> */}
          </div>
        </div>
      </section>

      {/* Business Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-12">
            <Badge variant="outline" className="mb-3 text-sm border-blue-300 text-blue-700 bg-blue-50">
              企业服务
            </Badge>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              多元化业务体系
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              提供从软件开发到数据服务的全链条解决方案
            </p>
          </div> */}

          <div className="space-y-8">
            {/* 板块1：定制化软件开发服务 */}
            <Card className="border-0 shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-3xl">
                    💻
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-1">定制化软件开发服务</h3>
                    <p className="text-blue-100 text-sm">
                      依托光学与信息技术领域的技术积累，为众多科研院所和企业提供技术支持
                    </p>
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-6 leading-relaxed">
                  提供定制化软件开发服务，涵盖行业应用软件、人工智能应用开发、软件外包与运维升级等，打造适配业务场景的数字化解决方案。
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {[
                    { icon: "🌐", title: "企业官网定制开发", desc: "品牌官网设计与开发，运维升级服务" },
                    { icon: "⚙️", title: "行业应用软件定制", desc: "垂直行业解决方案，业务流程数字化" },
                    { icon: "🤖", title: "人工智能应用开发", desc: "AI算法集成与迭代，智能化业务升级" },
                    { icon: "🔧", title: "软件外包与技术支持", desc: "项目外包服务，全周期技术支撑" }
                  ].map((item, index) => (
                    <div key={index} className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-lg p-4 hover:shadow-md transition-shadow duration-300">
                      <div className="text-3xl mb-3">{item.icon}</div>
                      <h4 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h4>
                      <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* 板块3：光学仪器与配套设备 */}
            <Card className="border-0 shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-indigo-500 to-purple-600 p-6">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-3xl">
                    🔭
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-1">光学仪器与配套设备</h3>
                    <p className="text-indigo-100 text-sm">
                      提供光学仪器、通用仪器仪表及配套设备的销售服务
                    </p>
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-6 leading-relaxed">
                  适配光学检测、科研实验、工业测量等场景，可根据客户需求提供仪器选型、配套部署等一站式服务。
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {[
                    { icon: "📷", title: "光学仪器及配件销售", desc: "镜头、光源、探测器等光学元器件与整机设备" },
                    { icon: "📊", title: "通用仪器仪表配套", desc: "光谱仪、干涉仪、显微镜等科研与工业仪器" },
                    { icon: "💡", title: "仪器设备选型咨询", desc: "根据应用场景提供专业的仪器选型建议" },
                    { icon: "🛠️", title: "配套部署与技术支持", desc: "现场安装调试、及售后维护服务" }
                  ].map((item, index) => (
                    <div key={index} className="bg-gradient-to-br from-indigo-50 to-white border border-indigo-100 rounded-lg p-4 hover:shadow-md transition-shadow duration-300">
                      <div className="text-3xl mb-3">{item.icon}</div>
                      <h4 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h4>
                      <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* 板块4：数据与信息技术服务 */}
            <Card className="border-0 shadow-lg overflow-hidden">
              <div className="bg-gradient-to-r from-cyan-500 to-blue-600 p-6">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-3xl">
                    📈
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-1">数据与信息技术服务</h3>
                    <p className="text-cyan-100 text-sm">
                      围绕数据全生命周期提供专业服务
                    </p>
                  </div>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-gray-600 mb-6 leading-relaxed">
                  包括数据处理、数据存储支持服务、卫星遥感数据处理及相关技术咨询，为客户提供安全、高效的数据解决方案。
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  {[
                    { icon: "🗄️", title: "数据处理与存储服务", desc: "海量数据清洗、转换、归档及云存储方案" },
                    { icon: "🌍", title: "卫星遥感数据处理", desc: "遥感影像预处理、解译分析及专题信息提取" },
                    { icon: "🏗️", title: "数据平台建设", desc: "数据中台、可视化平台及业务系统定制开发" },
                    { icon: "📋", title: "信息技术咨询服务", desc: "IT架构规划、技术选型及数字化转型咨询" }
                  ].map((item, index) => (
                    <div key={index} className="bg-gradient-to-br from-cyan-50 to-white border border-cyan-100 rounded-lg p-4 hover:shadow-md transition-shadow duration-300">
                      <div className="text-3xl mb-3">{item.icon}</div>
                      <h4 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h4>
                      <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {products.map((product, index) => {
              const colorClasses = getColorClasses(product.color);
              
              return (
                <Card key={product.id} className="border-0 shadow-lg overflow-hidden">
                  <div className={`bg-gradient-to-r ${product.color === 'blue' ? 'from-blue-500 to-blue-600' : 'from-purple-500 to-purple-600'} p-6`}>
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center text-white">
                        {product.icon}
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-white mb-1">{product.title}</h3>
                        <p className="text-white/90 text-sm">{product.subtitle}</p>
                      </div>
                    </div>
                  </div>
                  <CardContent className="p-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                      {/* Left: Image and Description */}
                      <div>
                        <div className="relative mb-6">
                          <div className={`absolute inset-0 ${colorClasses.bg} rounded-2xl transform rotate-2 opacity-50`}></div>
                          <img 
                            src={product.image} 
                            alt={product.title}
                            className="relative rounded-xl shadow-lg w-full"
                          />
                        </div>
                        <p className="text-gray-600 leading-relaxed mb-6">
                          {product.description}
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3">
                          <Button className={`${colorClasses.button} text-white text-sm px-4`} asChild>
                            <Link to="/trial">
                              免费使用 <ArrowRight className="ml-1.5 w-3.5 h-3.5" />
                            </Link>
                          </Button>
                          <Button variant="outline" size="sm">
                            <Download className="mr-1.5 w-3.5 h-3.5" />
                            下载手册
                          </Button>
                        </div>
                      </div>

                      {/* Right: Features */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-4">核心功能</h4>
                        <div className="space-y-3">
                          {product.features.map((feature, idx) => (
                            <div key={idx} className={`bg-gradient-to-br ${product.color === 'blue' ? 'from-blue-50 to-white border-blue-100' : 'from-purple-50 to-white border-purple-100'} border rounded-lg p-4 hover:shadow-md transition-shadow duration-300`}>
                              <div className="flex items-start gap-3">
                                <div className={`${colorClasses.bg} ${colorClasses.text} p-2 rounded-lg flex-shrink-0`}>
                                  {feature.icon}
                                </div>
                                <div>
                                  <h5 className="font-semibold text-gray-900 mb-1.5 text-sm">{feature.title}</h5>
                                  <p className="text-xs text-gray-600 leading-relaxed">{feature.description}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Detailed Features */}
      {/* <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              产品功能详情
            </h2>
            <p className="text-base text-gray-600">
              深入了解每个产品的核心功能和技术特点
            </p>
          </div>

          <div className="space-y-12">
            {products.map((product) => {
              const colorClasses = getColorClasses(product.color);
              
              return (
                <div key={product.id} id={product.id} className="scroll-mt-20">
                  <Card className="overflow-hidden">
                  <CardHeader className={`${colorClasses.bg} ${colorClasses.text} py-4 px-6`}>
                    <CardTitle className="flex items-center space-x-2.5 text-lg">
                      {product.icon}
                      <span>{product.name} - {product.title}</span>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {/* Features */}
                      {/* <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">核心功能</h3>
                        <div className="space-y-3">
                          {product.features.map((feature, idx) => (
                            <div key={idx} className="border rounded-lg p-3">
                              <div className="flex items-start space-x-2.5">
                                <div className={`${colorClasses.bg} ${colorClasses.text} p-1.5 rounded-lg flex-shrink-0`}>
                                  {feature.icon}
                                </div>
                                <div>
                                  <h4 className="font-medium text-gray-900 mb-1.5 text-sm">{feature.title}</h4>
                                  <p className="text-gray-600 text-xs leading-relaxed">{feature.description}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div> */}

                      {/* Capabilities */}
                      {/* <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">技术能力</h3>
                        <div className="space-y-2.5">
                          {product.capabilities.map((capability, idx) => (
                            <div key={idx} className="flex items-start space-x-2.5">
                              <CheckCircle className={`${colorClasses.text} w-4 h-4 flex-shrink-0 mt-0.5`} />
                              <p className="text-gray-600 text-sm leading-relaxed">{capability}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
                </div>
              );
            })}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
            准备开始您的项目？
          </h2>
          <p className="text-base text-blue-100 mb-6">
            立即试用，体验专业的光学仿真解决方案
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button size="default" variant="secondary" asChild>
              <Link to="/trial">
                免费使用 <ArrowRight className="ml-1.5 w-3.5 h-3.5" />
              </Link>
            </Button>
            <Button size="default" variant="outline" className="text-white border-white hover:bg-white hover:text-blue-600" asChild>
              <Link to="/contact">
                联系销售
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Products;
